export default __webpack_public_path__ + "static/media/logo-white.7fa9be1a.png";